<script>
export default {
	name: "List"
}
</script>

<template>
	<ul role="list" class="divide-y divide-gray-100">
		<slot></slot>
	</ul>
</template>

<style scoped>

</style>